import { render, staticRenderFns } from "./world-map-viewer.vue?vue&type=template&id=334b1925&"
import script from "./world-map-viewer.vue?vue&type=script&lang=js&"
export * from "./world-map-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports